import { notifyBugsnag } from 'utils/util';
import { getCurrentVehicleByVin } from 'framework/dataService/vehicle';
import type { CustomJsonSchemaProps } from '../../../interfaces/CustomJsonSchemaProps';

export const inRuleMap = {
  propertyDamage: (
    schema: CustomJsonSchemaProps,
    data: any,
    fieldSchema: any,
    validationType: any,
    fieldName: any,
    rule: any,
    errors?: any
  ) => {
    let isError = false;
    let warningMsgs: any[] = [];

    // WI OH TN IN  can reuse
    const pdLimit = data?.propertyDamage;
    const bodilyInjury = data?.bodilyInjury?.split('/');
    if (bodilyInjury.length > 0 && pdLimit) {
      let errorValidation = false;
      const biPerPerson = bodilyInjury[0];
      if (parseInt(biPerPerson) === 25) {
        if (parseInt(pdLimit) > 25) {
          errorValidation = true;
        }
      } else if (parseInt(biPerPerson) === 50) {
        if (parseInt(pdLimit) > 50 || parseInt(pdLimit) < 25) {
          errorValidation = true;
        }
      } else if (parseInt(biPerPerson) === 100) {
        if (parseInt(pdLimit) > 100 || parseInt(pdLimit) < 50) {
          errorValidation = true;
        }
      }
      if (errorValidation) {
        const messages: any = fieldSchema.messages;
        let errorMessage = messages?.[validationType];
        isError = true;
        if (errors && errorMessage && data[fieldName] !== undefined) {
          notifyBugsnag('Custom Form validation Error - propertyDamage', {
            errorMessage,
            inputData: data,
          });
          errors[fieldName].addError(errorMessage);
        }
      }
    }
    return { isError, warningMsgs };
  },
  uimCompare: (
    schema: CustomJsonSchemaProps,
    data: any,
    fieldSchema: any,
    validationType: any,
    fieldName: any,
    rule: any,
    errors?: any
  ) => {
    // TODO   Exception:  When limit = 25/50 UM & 50/50 UIM.  In this case, BI 25/50 = UM 25/50 & UIM 50/100
    let isError = false;
    let warningMsgs: any[] = [];
    const bodilyInjury = data?.bodilyInjury?.split('/');
    const uimLimit =
      data?.uim?.toLowerCase() !== 'declined'
        ? data?.uim.includes('UM')
          ? data?.uim.split(' UM')[0].split('/')
          : data?.uim?.split('/')
        : [];
    if (
      bodilyInjury?.length > 0 &&
      uimLimit.length > 0 &&
      parseInt(bodilyInjury[0], 10) < parseInt(uimLimit[0], 10)
    ) {
      const messages: any = fieldSchema.messages;
      let errorMessage = messages?.[validationType];
      isError = true;
      if (errors && errorMessage && data[fieldName] !== undefined) {
        notifyBugsnag('Custom Form validation Error - uimCompare', {
          errorMessage,
          inputData: data,
        });
        errors[fieldName].addError(errorMessage);
      }
    }

    return { isError, warningMsgs };
  },
  umpdCoverage: (
    schema: CustomJsonSchemaProps,
    data: any,
    fieldSchema: any,
    validationType: any,
    fieldName: any,
    rule: any,
    errors?: any
  ) => {
    let isError = false;
    let warningMsgs: any[] = [];
    const pdLimit = data?.propertyDamage;
    const uimLimit = data?.uim;
    const uimLimitNotDeclined =
      data?.uim?.toLowerCase() !== 'declined' ? data?.uim?.split('/') : [];
    const isUimDeclined = data?.uim && data?.uim?.toLowerCase() === 'declined';
    const isUmpdDeclined =
      data?.umpd && data?.umpd?.toLowerCase() === 'declined';
    const umpdLimit =
      data?.umpd?.toLowerCase() !== 'declined' ? data?.umpd?.split(' ') : [];
    let umpdValidation = false;
    let umpdUimValidation = false;
    let errorValidation = false;
    if (
      pdLimit &&
      umpdLimit.length > 0 &&
      parseInt(umpdLimit[0], 10) > pdLimit
    ) {
      umpdValidation = true;
    }
    if (!isUmpdDeclined && isUimDeclined) {
      umpdUimValidation = true;
    }

    if (uimLimit.toLowerCase() == 'declined') {
      if (data?.umpd?.toLowerCase() != 'declined') {
        errorValidation = true;
        umpdUimValidation = true;
      }
    } else if (parseInt(uimLimitNotDeclined?.[0], 10) == 25) {
      if (
        !(
          parseInt(umpdLimit[0], 10) == 25 ||
          data?.umpd?.toLowerCase() == 'declined'
        )
      ) {
        errorValidation = true;
        umpdUimValidation = true;
      }
    } else if (parseInt(uimLimitNotDeclined?.[0], 10) == 50) {
      if (
        !(
          parseInt(umpdLimit[0], 10) == 25 ||
          parseInt(umpdLimit[0], 10) == 50 ||
          data?.umpd?.toLowerCase() == 'declined'
        )
      ) {
        errorValidation = true;
        umpdUimValidation = true;
      }
    } else if (parseInt(uimLimitNotDeclined?.[0], 10) == 100) {
      if (
        !(
          parseInt(umpdLimit[0], 10) == 50 ||
          parseInt(umpdLimit[0], 10) == 100 ||
          data?.umpd?.toLowerCase() == 'declined'
        )
      ) {
        errorValidation = true;
        umpdUimValidation = true;
      }
    }

    if (umpdValidation || umpdUimValidation || errorValidation) {
      const messages: any = fieldSchema.messages;
      let errorMessage = umpdUimValidation
        ? messages?.umpdUimCoverage
        : messages?.[validationType];
      isError = true;
      if (errors && errorMessage && data[fieldName] !== undefined) {
        notifyBugsnag('Custom Form validation Error - uimCompare', {
          errorMessage,
          inputData: data,
        });
        errors[fieldName].addError(errorMessage);
      }
    }
    return { isError, warningMsgs };
  },
  comprehensiveDeductible: (
    schema: CustomJsonSchemaProps,
    data: any,
    fieldSchema: any,
    validationType: any,
    fieldName: any,
    rule: any,
    errors?: any
  ) => {
    let isError = false;
    let warningMsgs: any[] = [];
    let errorFieldsExists = false;
    const financeCase = ['financed', 'lease'];
    data.vehiclesList &&
      data?.vehiclesList.forEach((vehicle: any, index: number) => {
        const currentVin = getCurrentVehicleByVin(vehicle?.vin);
        const compDed =
          vehicle?.comprehensiveDeductible?.toLowerCase() === 'declined'
            ? ['declined']
            : vehicle?.comprehensiveDeductible?.split(' DED');
        const collDed =
          vehicle?.collisionDeductible?.toLowerCase() === 'declined'
            ? ['declined']
            : vehicle?.collisionDeductible?.split(' DED');

        if (compDed?.length > 0 && collDed?.length > 0) {
          let showErrorMessage = false;
          let financedErrorMessage = false;
          if (
            currentVin &&
            financeCase.includes(currentVin?.ownershipStatus?.toLowerCase()) &&
            compDed[0] === 'declined'
          ) {
            showErrorMessage = true;
            financedErrorMessage = true;
          }
          if (collDed[0] !== 'declined' && compDed[0] === 'declined') {
            showErrorMessage = true;
          }
          if (showErrorMessage) {
            const messages: any = fieldSchema.messages;
            let errorMessage = financedErrorMessage
              ? messages?.comprehensiveDecline
              : messages?.[validationType];
            errorFieldsExists = true;
            if (errors && errorMessage && data[fieldName] !== undefined) {
              notifyBugsnag(
                'Custom Form validation Error - comprehensiveDeductible',
                { errorMessage, inputData: data }
              );
              errorFieldsExists = true;
              if (errorMessage === messages?.[validationType]) {
                errors[fieldName][index].collisionDeductible.addError(
                  errorMessage
                );
              } else {
                errors[fieldName][index].comprehensiveDeductible.addError(
                  errorMessage
                );
              }
            }
          }
        }
      });
    if (errorFieldsExists) {
      isError = true;
    }
    return { isError, warningMsgs };
  },
};
